import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ToggleButton from '@material-ui/lab/ToggleButton'
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'

import { useStyles } from './styles'
import { products } from '../../../../constants/production-panel'
import { setProductsControlPanel } from '../../../../store/actions/controlPanel'
import { setHandleAlert } from '../../../../store/actions/common'

const Products = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { oil, water, gas } = products
  const productsList = [oil.value, water.value, gas.value]
  const productsToggleValues = useSelector(
    (state) => state.controlPanel.products
  )

  /* For render component */
  const toggleValues = [
    { label: oil.label, value: oil.value },
    { label: water.label, value: water.value },
    { label: gas.label, value: gas.value },
  ]

  useEffect(() => {
    dispatch(setProductsControlPanel(productsList))
  }, [])

  const handleFormat = (event, newFormats) => {
    newFormats.length < 1
      ? showAlertMessage(
          'You must select at least one product',
          true,
          'warning'
        )
      : dispatch(setProductsControlPanel(newFormats))
  }

  const renderToggles = toggleValues.map((toggle) => (
    <ToggleButton
      key={toggle.label}
      value={toggle.value}
      classes={{ selected: classes.selected }}
      id={`toggleButtonFilter${toggle.value}`}
    >
      <strong id={`toggleButtonLabelFilter${toggle.label}`}>
        {toggle.label}
      </strong>
    </ToggleButton>
  ))

  const showAlertMessage = (message, status, severity) => {
    dispatch(
      setHandleAlert({
        message,
        status,
        severity,
      })
    )
  }

  return (
    <div className={classes.container}>
      <ToggleButtonGroup
        value={productsToggleValues}
        onChange={handleFormat}
        aria-label="text formatting"
        size="small"
      >
        {renderToggles}
      </ToggleButtonGroup>
    </div>
  )
}

export default Products
